import { useCallback } from "react";

import type { Template } from "./types";

export function useContract(templateID: string) {
  const transform = useCallback(
    (fields: any, template: Template) => {
      const splitArrayIntoChunksOfLen = (arr: [], len: number) => {
        let chunks = [],
          i = 0,
          n = arr.length;
        while (i < n) {
          chunks.push(arr.slice(i, (i += len)));
        }
        return chunks;
      };

      const components = splitArrayIntoChunksOfLen(fields, 8);

      const forms = components.map((c) => {
        return {
          name: template.name,
          components: c,
        };
      });

      return {
        templateID,
        name: template.name,
        forms,
      };
    },
    [templateID]
  );

  return transform;
}

export function shouldDisabledInput(contract: any) {
  return contract.status === "SIGNED" || contract.status === "VOID"
    ? true
    : false;
}
